import { Component, OnInit,HostListener, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { ROLE_COTISTA_CONSULTA, ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Tranche } from 'src/app/model/tranche.model';
import { LimitesFundo } from 'src/app/model/limite-agente-financeiro.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { LimiteService } from 'src/app/shared/services/limite.service';
import { ModalidadeService } from 'src/app/shared/services/modalidade.service';
import { ModalidadeGarantia } from '../../../model/modalidade_garantia.model';
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import {BnModalMessageService} from '@bndes/bndes-ux4/bn-modal-message';
import { LimiteAdicionalService } from 'src/app/features/limite-adicional/limite-adicional.service';
import { OpcaoFiltro } from 'src/app/model/opcao-filtro.model';



@Component({
    selector: 'app-limite-pesquisa',
    templateUrl: './limite-pesquisa.component.html',
    styleUrls: ['./limite-pesquisa.component.scss'],
    standalone: false
})
export class LimitePesquisaComponent implements OnInit {

    public cnpjUsuario: string;
    public agenteFinanceiro: AgenteFinanceiro;
    public agentesFinanceiros: AgenteFinanceiro[] = [];
    public tranches: Tranche[] = [];
    public podeEscolherAgente: boolean;
    public podePesquisarAgente: boolean;
    public podeCadastrarLimiteAgente: boolean = false;
    public podeCadastrarLimiteFundo: boolean = false;

    public agenteFinanceiroPesquisa: AgenteFinanceiro;
    public modalidade: ModalidadeGarantia;
    public ideTranche: number;
    public trancheSelecionada: Tranche;
    public refresh: number = 0;

    public limitesFundo: LimitesFundo;
    public limitesFundoTranchesPassadas: LimitesFundo[];
    public dataReferenciaLimiteFundo: Date[];
    public dataLimitePesquisa: string;
    public ehFGBS: boolean;
    public ehFGE: boolean;
    @ViewChild('bodyListagemValorTipoPagamentoECG') msgListagemValorTipoPagamentoECG: TemplateRef<any>;

    public limitesAdicionaisOpcoes: OpcaoFiltro[] = [];
    public ideLimiteAdicionalSelecionado: number;


    constructor(
        private permissaoService: PermissaoService,
        private limiteService: LimiteService,
        private bnUsuarioService: BnUsuarioService,
        private activatedRoute: ActivatedRoute,
        private modalidadeService: ModalidadeService,
        private bnLoadingService: BnLoadingService,
        private limiteAdicionalService: LimiteAdicionalService,
        private modalService: BnModalMessageService,
    ) { }

    @HostListener('window:keydown.enter', ['$event'])
    keyEvent(event: KeyboardEvent){
      this.buscar()
    }

    public ngOnInit() {
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
        	this.limitesFundo = this.activatedRoute.snapshot.data['limites']; //resolver

            if ((resp[ROLE_GESTOR_CONSULTA] || resp[ROLE_GESTOR_ENVIO] || resp[ROLE_COTISTA_CONSULTA])) {
                this.limiteService.getLimitesFundoTranchesPassadas()
                    .subscribe((listaLimites: LimitesFundo[])=>{
                        this.limitesFundoTranchesPassadas = listaLimites;
                    });
            }

            this.dataReferenciaLimiteFundo = this.activatedRoute.snapshot.data['dataReferenciaLimiteFundo']; // resolver
            this.tranches = this.activatedRoute.snapshot.data['tranches']; //resolver
            this.dataLimitePesquisa = moment().format('YYYY-MM-DD HH:mm:ss');

            this.podePesquisarAgente = resp && (resp[ROLE_GESTOR_CONSULTA] || resp[ROLE_GESTOR_ENVIO]);
            this.podeEscolherAgente = resp && (resp[ROLE_GESTOR_CONSULTA] || resp[ROLE_GESTOR_ENVIO] || resp[ROLE_COTISTA_CONSULTA]);
            this.podeCadastrarLimiteAgente = resp && resp[ROLE_GESTOR_ENVIO]

            this.modalidadeService.modalidade$.subscribe((mod) =>{
                this.podeCadastrarLimiteFundo = resp && resp[ROLE_GESTOR_ENVIO] ||
                                                resp && resp[ROLE_GESTOR_CONSULTA];

                for (let modalidade of this.modalidadeService.getModalidades()) {
                    if (modalidade.sigla == mod) {
                        this.modalidade = modalidade;
                    }
                }
            })

            this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes']; //resolver

            if (this.podeEscolherAgente) {
                this.atribuiAgenteFinanceiro(-1);
            }
            else {
                this.bnUsuarioService.usuario$.subscribe(usuario => {
                    if (usuario) {
                        this.cnpjUsuario = usuario.cnpj;

                        this.atribuiAgenteFinanceiro(this.cnpjUsuario);
                    }
                });
            }

             this.ehFGE = this.modalidade.sigla === 'FGE';

            this.ehFGBS = this.modalidade.sigla === 'FGBS';
            if (this.ehFGBS) {
                let idTranche = this.tranches[0].id;
                this.atribuiTranche(idTranche);
            }

        });
     }

    atribuiAgenteFinanceiro(cnpj) {
        if (!cnpj) {
            this.agenteFinanceiro = undefined;
        }
        else if (cnpj == -1) { // Todos
            this.agenteFinanceiro = new AgenteFinanceiro();
            this.agenteFinanceiro.id = -1;
        }
        else {
            for (let agente of this.agentesFinanceiros) {
                if (agente.cnpj == cnpj) {
                    this.agenteFinanceiro = agente;
                }
            }
        }
    }

    atribuiTranche(ide) {
        this.ideTranche = ide;
        this.trancheSelecionada = this.tranches.find(tranche => tranche.id == ide);
        this.ideLimiteAdicionalSelecionado = undefined;   // default: Global
        this.carregarLimitesAdicionais(ide);
        this.buscar();
        }

    atribuiLimite(valor) {
        this.ideLimiteAdicionalSelecionado = valor ? Number(valor) : undefined;
        this.buscar();
    }
    
    carregarLimitesAdicionais(ideTranche) {
        this.limitesAdicionaisOpcoes = [];

        if (!ideTranche) {
            return;
        }
        

        this.limiteAdicionalService.buscarLimitesAdicionaisPorTranche(ideTranche)
            .subscribe(opcoes => this.limitesAdicionaisOpcoes = opcoes);
    }

    atualizarLimiteFundo() {
        this.limiteService.getLimitesFundo().subscribe(limite => {
            this.limitesFundo = limite;
            // FIXME: Usar a data que vem do back-end
            this.dataLimitePesquisa = moment().format('YYYY-MM-DD HH:mm:ss');
        });
    }

    buscar() {
        console.log('SELECIONADO', this.ideLimiteAdicionalSelecionado);
        
        if(this.ideTranche){
        this.atualizarLimiteFundo();
        this.agenteFinanceiroPesquisa = this.agenteFinanceiro;
        this.refresh++;
        }
    }

     abrirModalListagem(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean) {
        if (hasBotoes === true && hasMsgTemplate === true) {
          this.modalService.abrir('Valores cedidos para pagamento ECG por terceiros', msg, tamanho, this.msgListagemValorTipoPagamentoECG);
       }
  }


}
